import { request } from "./request";

const BASE_URL = "/api/modules";

export default {
  async fetchSalaryCalculatorData() {
    return await request(`${BASE_URL}/salary_calculator`);
  },

  async fetchSalaryCalculatorFormData() {
    return await request(`${BASE_URL}/salary_calculator/form`);
  },

  async fetchPayrollCalculatorFormData() {
    return await request(`${BASE_URL}/salary_calculator/payroll_form`);
  },

  async fetchSalaryMedian(country) {
    return await request(
      `${BASE_URL}/salary_calculator/median?country=${country}`
    );
  },

  async calculateSalary(data) {
    return await request({
      method: "POST",
      url: `${BASE_URL}/salary_calculator`,
      data: {
        country_of_residence: data.countryOfResidence,
        currency: data.currency,
        work_role: data.workRole,
        marital_status: data.maritalStatus,
        marital_money_maker: data.maritalMoneyMaker,
        income: data.income,
        type: data.type,
      },
    });
  },
};
